import AnimatedTimelineItem from "../desktop/AnimatedTimelineItem";

const MobileTimeline = () => {
  return (
    <div className='flex flex-col items-center font-display text-navy justify-center'>

        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 1973 */}
        <div className='flex justify-center space-x-4 pt-6'>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'/timeline/masseysr.webp'} class='w-full h-full object-cover'/>
            </div>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>1973</div>
                <div class='text-2xl pt-3 font-semi'>Branford, CT</div>
            </div>
        </div>
        <div className='text-center p-4'>
            <div>Massey's is founded in a 3-car garage and begins work as a small commercial and residential firm.</div>
        </div>
        </AnimatedTimelineItem>

        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 1978 */}
        <div className='flex justify-center space-x-4 pt-4'>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>1978</div>
                <div class='text-2xl pt-3 font-semi'>Branford, CT</div>
            </div>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'/timeline/masseystruck.webp'} class='w-full h-full object-cover'/>
            </div>
        </div>
        <div className='text-center p-4'>
            <div>Massey's moves to its new and current headquarters
            on East Main Street in Branford, 
            this location would have future expansion in 1986, 1997, 1999, 
            2008, and 2014 builds new facility on Baldwin Drive.
            </div>
        </div>
        </AnimatedTimelineItem>

        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 1989 */}
        <div className='flex justify-center space-x-4 pt-8'>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'/timeline/onecentury.webp'} class='w-full h-full object-cover'/>
            </div>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>1989</div>
                <div class='text-2xl pt-3 font-semi'>New Haven, CT</div>
            </div>
        </div>
        <div className='text-center p-4'>
            <div>One Century Tower becomes Massey's largest project yet, venturing into the world of healthcare
            construction and forging a relationship with Blue Cross Blue Shield.</div>
        </div>
        </AnimatedTimelineItem>

        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 1991 */}
        <div className='flex justify-center space-x-4 pt-8'>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>1991</div>
                <div class='text-2xl pt-3 font-semi'>Branford, CT</div>
            </div>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'/timeline/mohegan_sun_new.webp'} class='w-full h-full object-cover'/>
            </div>
        </div>
        <div className='text-center p-4'>
            <div>
                Casino work becomes a new Massey's specialty, beginning with Foxwoods Casino and Mohegan Sun
            shortly after.
            </div>
        </div>
        </AnimatedTimelineItem>

        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 1998 */}
        <div className='flex justify-center space-x-4 pt-8'>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'/timeline/prov.webp'} class='w-full h-full object-cover'/>
            </div>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>1998</div>
                <div class='text-2xl pt-3 font-semi'>Providence, RI</div>
            </div>
        </div>
        <div className='text-center p-4'>
            <div>Massey's opens their Providence office.</div>
        </div>
        </AnimatedTimelineItem>
        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 2006 */}
        <div className='flex justify-center space-x-4 pt-8'>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>2006</div>
                <div class='text-2xl pt-3 font-semi'>Branford, CT</div>
            </div>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'/timeline/uam.webp'} class='w-full h-full object-cover'/>
            </div>
        </div>
        <div className='text-center p-4'>
            <div>
                Massey's partners with United Architectural Metals for specialty unitized glazing projects.
            </div>
        </div>
        </AnimatedTimelineItem>

        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 2008 */}
        <div className='flex justify-center space-x-4 pt-8'>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'/timeline/aps.webp'} class='w-full h-full object-cover'/>
            </div>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>2008</div>
                <div class='text-2xl pt-3 font-semi'>Branford, CT</div>
            </div>
        </div>
        <div className='text-center p-4'>
            <div>All Panels Systems is founded, establishing material suppliers and subcontractors in-house, 
            and beginning work in waterproofing and firestop (FM Global)</div>
        </div>
        </AnimatedTimelineItem>

        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 2010 */}
        <div className='flex justify-center space-x-4 pt-8'>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>2010</div>
                <div class='text-2xl pt-3 font-semi'>Branford, CT</div>
            </div>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'/timeline/menino.webp'} class='w-full h-full object-cover'/>
            </div>
        </div>
        <div className='text-center p-4'>
            <div>
                Massey's comes to Boston 
                and begins its first large project there with the Boston Medical Menino Expansion.
            </div>
        </div>
        </AnimatedTimelineItem>

        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 2012 */}
        <div className='flex justify-center space-x-4 pt-8'>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'timeline/foxborough.webp'} class='w-full h-full object-cover'/>
            </div>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>2012</div>
                <div class='text-2xl pt-3 font-semi'>Foxborough, MA</div>
            </div>
        </div>
        <div className='text-center p-4'>
            <div> The Foxborough office opens its doors for the first time.</div>
        </div>
        </AnimatedTimelineItem>

        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 2014 */}
        <div className='flex justify-center space-x-4 pt-8'>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>2014</div>
                <div class='text-2xl pt-3 font-semi'>Boston, MA</div>
            </div>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'/timeline/88seaport.webp'} class='w-full h-full object-cover'/>
            </div>
        </div>
        <div className='text-center p-4'>
            <div>
                An outpour of Boston projects
                paves the way for Massey's to become a top player in the city.
            </div>
        </div>
        </AnimatedTimelineItem>

        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 2016 */}
        <div className='flex justify-center space-x-4 pt-8'>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'/timeline/fabbrica.webp'} class='w-full h-full object-cover'/>
            </div>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>2016</div>
                <div class='text-2xl pt-3 font-semi'>Branford, CT</div>
            </div>
        </div>
        <div className='text-center p-4'>
            <div> Massey's partners with Fabbrica
            for larger custom architectural and unitized facades across the Northeast.
            </div>
        </div>
        </AnimatedTimelineItem>

        <div className="border-t border-sky-950 w-full"></div>

        <AnimatedTimelineItem>
        {/* 2023 */}
        <div className='flex justify-center space-x-4 pt-8'>
            <div className='flex flex-col items-center justify-center'>
                <div class='text-5xl font-bold'>2023</div>
                <div class='text-2xl pt-3 font-semi'>Franklin, MA</div>
            </div>
            <div className='flex flex-col rounded-xl aspect-square overflow-hidden w-2/5'>
                <img src={'/timeline/50yrs.webp'} class='w-full h-full object-cover'/>
            </div>
        </div>
        <div className='text-center p-4 pb-8'>
            <div>
                Massey's celebrates 50 years and sets up shop at its new Franklin office.
            </div>
        </div>
        </AnimatedTimelineItem>
    </div>
  )
}

export default MobileTimeline
